import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=aec05374&scoped=true"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidget.vue?vue&type=style&index=0&id=aec05374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec05374",
  null
  
)

export default component.exports